import { useMemo } from 'react'
import styled from '@emotion/styled'
import { CvsTextField } from '@components'
import { DeleteButton } from './delete-button'
import {
  IntegrationAssignedFilter,
  IntegrationFilter,
  IntegrationFilterValue,
} from './filter-types'

const FullWidth = styled.div`
  width: 100%;
  display: flex;
  margin-top: 8px;
  margin-bottom: 4px;
`

const FullWidthTextField = styled(CvsTextField as any)`
  width: 100%;
`

interface Props {
  filter: IntegrationAssignedFilter
  filterOption: IntegrationFilter
  error?: string | boolean
  onFilterChange: (value: IntegrationFilterValue[], filter: IntegrationAssignedFilter) => void
  onFilterDelete: (filter: IntegrationAssignedFilter) => void
}

export const TextFilter = ({
  filter,
  filterOption,
  error = false,
  onFilterChange,
  onFilterDelete,
}: Props) => {
  const selectedValue = filter.values.length ? filter.values.map(f => f.value)[0] : undefined

  function handleFilterChange(value: string): void {
    const filterValue: IntegrationFilterValue[] = [
      {
        integration_assignment_filters_id: filter.id,
        value,
        display_name: value,
      },
    ]
    onFilterChange(filterValue, filter)
  }

  const textError = useMemo(() => {
    if (typeof error === 'string') {
      return [error]
    }

    return !selectedValue || selectedValue.trim() == '' ? ['Please enter a value.'] : []
  }, [selectedValue, error])

  return (
    <FullWidth>
      <FullWidthTextField
        margin="dense"
        variant="outlined"
        label={filterOption.displayName}
        value={selectedValue}
        onChange={e => {
          handleFilterChange(e.target.value)
        }}
        error={textError}
      />
      <DeleteButton
        filter={filter}
        required={filterOption.required}
        onFilterDelete={onFilterDelete}
        marginTop={!selectedValue || selectedValue.trim() == '' ? -16 : 2}
      />
    </FullWidth>
  )
}
